import { Grid, List, Typography, Box, Avatar, Chip, Paper } from "@mui/material"
import EditLocationAltIcon from '@mui/icons-material/EditLocationAlt'
import { useAppSelector } from "../../../../../../../hooks/store-hooks";
import { useListaDeduplicacaoService, useProjetosService } from "../../../../../../../../use-cases/geo-veles";
import { useEffect, useState } from "react";

export const PreviaFiltroDeduplicacao = () => {
  // State
  const { projetos: { filtrosSelecionados }, listaDeduplicacao } = useAppSelector((state) => state)
  // useState
  const [loading, setLoading] = useState<boolean>(true)
  // Hook
  const { removeListaDeduplicacaoFilter } = useProjetosService()
  const { setupListaDeduplicacao } = useListaDeduplicacaoService()
  // useEffect
  useEffect(() => {
    setLoading(false)
  }, [])

  useEffect(() => {
    setupListaDeduplicacao()
  }, [setupListaDeduplicacao])

  return (
    <>
      {
        loading ? <></>
          :
          <List>
            {
              (filtrosSelecionados?.listasDeduplicacao?.length ?? 0) > 0 && (
                <Paper elevation={2} sx={{ my: 2, p: 2 }} >
                  < Box my={3}>
                    <Typography color="primary" fontWeight={"bold"}>
                      Listas de deduplicação selecionadas:
                    </Typography>
                  </Box>
                  <Grid container spacing={3}>
                    {filtrosSelecionados?.listasDeduplicacao?.map((deduplicacaoList, index) => {
                      return (
                        <Grid item marginBottom={2} key={index}>
                          <Chip
                            label={listaDeduplicacao.listasDeduplicacao.find((listaDeduplicacaoState) => listaDeduplicacaoState.IdVelesGeoListaDeduplicacao === deduplicacaoList)?.Nome.toUpperCase()}
                            sx={{
                              height: 'auto',
                              '& .MuiChip-label': {
                                transition: '0.1s all',
                                display: 'block',
                                whiteSpace: 'normal',
                                padding: '10px 15px',
                                fontWeight: 'bold'
                              }
                            }}
                            color="primary"
                            onDelete={() => {
                              removeListaDeduplicacaoFilter(deduplicacaoList)
                            }}
                            avatar={
                              <Avatar
                                style={{
                                  cursor: 'pointer'
                                }}
                              >
                                <EditLocationAltIcon
                                  sx={{
                                    "&": {
                                      transition: '0.1s all'
                                    },
                                    "&:hover": {
                                      color: "secondary.main"
                                    }
                                  }} />
                              </Avatar>
                            }
                          />
                        </Grid>
                      )
                    })}
                  </Grid>
                </Paper>
              )
            }
          </List >
      }
    </>
  )
}